<template>
  <div>
    <v-tooltip top v-for="tag in reasonTags" :key="tag" class="mr-1">
      <v-chip
        slot="activator"
        outline
        color="red lighten-1"
      >
        <img :src="getTagIconUrl(tag)" :alt="getTagIconText(tag)" width="24px">
      </v-chip>
      <span>{{getTagName(tag)}}</span>
    </v-tooltip>
  </div>
</template>

<script>
import * as utils from '../../utils'

export default {
  props: {
    tags: {
      default: [],
      required: true
    }
  },

  data () {
    return {
      data: [],
      default_tags: []
    }
  },

  computed: {
    reasonTags () {
      return !this.tags ? [] : this.tags
    }
  },

  methods: {
    getTagName (code) {
      return utils.getTagName(this, code)
    },
    getTagIconText (code) {
      return utils.getTagIconText(code)
    },
    getTagIconUrl (code) {
      return utils.getTagIconUrl(code)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/components/TagReasonsList.vue